import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';

import Styled from './styled';
import Fragment from '../Fragment';

const ConditionToggle = ({
  disabled,
  value,
  onChange,
  isMobile,
}) => {
  const isDisabled = Boolean(!disabled);
  const props = {
    isDefaultChecked: value === 'or',
    onChange,
    size: isMobile ? 'regular' : 'large',
  };

  return (
    <Fragment>
      <Styled.OparatorLabel>AND</Styled.OparatorLabel>
      <Styled.Oparator>
        {isDisabled
          ? (
            <Tooltip position="top" content="No choice is made in the first condition">
              <Toggle {...props} isDisabled />
            </Tooltip>
          ) : (
            <Toggle {...props} />
          )}
      </Styled.Oparator>
      <Styled.OparatorLabel>OR</Styled.OparatorLabel>
    </Fragment>
  );
};

ConditionToggle.propTypes = {
  disabled: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

ConditionToggle.defaultProps = {
  disabled: 0,
  onChange: () => true,
  value: false,
};

export default ConditionToggle;
